import type { AppState } from 'types/app';

export const selectProducts = (state: AppState) => state?.products;

export const selectProductsList = (state: AppState) => selectProducts(state)?.list;
